import Cookies from 'universal-cookie'

export const PULSE_DATA_COOKIE = '_pulse2data'

export const extractPulseId = (value) => {
  if (typeof value === 'string') {
    return decodeURIComponent(value).split(',')[0]
  }
  return 'no_pulse_id'
}

export const getPulseCookie = (ctx) => {
  try {
    return ctx ? ctx.cookies.get(PULSE_DATA_COOKIE) : new Cookies().get(PULSE_DATA_COOKIE)
  } catch (e) {
    return undefined
  }
}

export const getPulseEnvId = (ctx) => {
  if (ctx) {
    // server-side
    return extractPulseId(getPulseCookie(ctx))
  }
  // client-side
  return extractPulseId(getPulseCookie())
}

export const getPulseOrigin = () => {
  const url = document.referrer

  if (url == null || url.length === 0) {
    // empty referrer
    return {
      id: 'n/a',
      type: 'n/a',
      url: ''
    }
  }
  if (/http\S+\/mina-annonser\/lagg-in-annons/i.test(url)) {
    // user came from slussen
    return {
      id: 'slussen-page',
      type: 'Page',
      url
    }
  }
  if (/http\S+\/$/i.test(url)) {
    // user came from frontpage
    return {
      id: 'front_page',
      type: 'Frontpage',
      url
    }
  }
  if (/http\S+\/mina-annonser\/annonsera\/ny\S*/i.test(url)) {
    // user came from form
    return {
      id: 'ai-form-page',
      type: 'Page',
      url
    }
  }
  return null
}
